import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightText'
})
export class HighlightTextPipe implements PipeTransform {
  transform(value: string, searchText: string): string {
    return !value || !searchText ? value : value.replace(new RegExp(searchText.trim(), 'gi'), '<b>$&</b>');
  }
}
